import { NavLink, Outlet, useNavigate, useParams } from "react-router";
import type { Me } from "../api.js";
import { useApi } from "../api.js";
import { useAuth } from "../auth.js";
import { Loading } from "./ui.js";

export function useOrg(): string {
  const { org } = useParams();
  return org ?? "";
}

export function Layout() {
  const org = useOrg();
  const auth = useAuth();
  const navigate = useNavigate();
  const me = useApi<Me>("/v1/me");

  const nav = [
    { to: `/o/${org}`, label: "Dashboard", end: true },
    { to: `/o/${org}/projects`, label: "Projects" },
    { to: `/o/${org}/runners`, label: "Runners" },
    { to: `/o/${org}/audit`, label: "Audit log" },
    { to: `/o/${org}/settings`, label: "Settings" },
  ];

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="brand">
          <img src="/favicon.svg" alt="" width={22} height={22} />
          <span>Forge</span>
        </div>
        {me.data && me.data.organisations.length > 0 && (
          <label className="org-switcher">
            <span className="sr-only">Organisation</span>
            <select
              value={org}
              onChange={(e) => {
                void navigate(`/o/${e.target.value}`);
              }}
            >
              {me.data.organisations.map((o) => (
                <option key={o.slug} value={o.slug}>
                  {o.name}
                </option>
              ))}
            </select>
          </label>
        )}
        <nav className="nav">
          {nav.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end === true} className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          {auth.user && (
            <div className="user">
              {auth.user.photoURL && <img src={auth.user.photoURL} alt="" width={24} height={24} />}
              <span title={auth.user.email ?? ""}>{auth.user.displayName ?? auth.user.email}</span>
            </div>
          )}
          <button
            className="link-button"
            onClick={() => {
              void auth.signOut();
            }}
          >
            Sign out
          </button>
        </div>
      </aside>
      <main className="content">{me.loading ? <Loading /> : <Outlet />}</main>
    </div>
  );
}
